import { HIERARCHY_TYPE_WITH_READONLY_LEGAL_INFO } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'

import { comparePartnerAddress } from './comparePartnerAddress'

export const shouldCopyAddress = (partner: IPartner) => {
  const isHierarchyTypeWithIndependentAddress = HIERARCHY_TYPE_WITH_READONLY_LEGAL_INFO.includes(
    partner.hierarchyType
  )

  if (partner.isNewPartner) {
    return false
  }

  if (isHierarchyTypeWithIndependentAddress) {
    return false
  }

  return comparePartnerAddress(partner)
}
